var map = {
	"./demos/basic/index.ts": 817,
	"./demos/beforeChange/index.ts": 17085,
	"./demos/closable/index.ts": 93724,
	"./demos/custom/index.ts": 46331,
	"./demos/customText/index.ts": 87271,
	"./demos/declarative/index.ts": 46940,
	"./demos/events/index.ts": 75528,
	"./demos/maskClosable/index.ts": 34683,
	"./demos/notarget/index.ts": 61568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7179;